// extracted by mini-css-extract-plugin
export default {"productGallery":"RI-z","inQuickShop":"SI-z"};